import React from 'react';
import { Navigate } from 'react-router';

import { ROUTES } from '@constants/routes';

import { useOrderContext } from '../hooks/useOrderContext';

/**
 * Route guard component that ensures users have completed eligibility check
 * before accessing the wizard. Redirects to eligibility check page if not eligible.
 */
export const WizardRouteGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { state, partner } = useOrderContext();

  if (!state.eligibilityChecked) {
    const redirectPath = partner
      ? `/${ROUTES.PARTNERSHIP}/${partner}/${ROUTES.ORDER_CHECK}`
      : `${ROUTES.ORDER}/${ROUTES.ORDER_CHECK}`;
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};
